import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import { BrandBand, WelcomeMatContainer } from '../../common/components';
import { DashboardNoData, Header, InfoCard, McMenu } from '../components/';
import { Card } from '@salesforce/design-system-react';

import './ContentSelectionRoot.scss';

export class ContentSelectionWelcome extends Component {
  renderWelcomeMat() {
    return <WelcomeMatContainer name="ecs" {...this.props} />;
  }

  render() {
    const helpLink =
      'https://help.salesforce.com/articleView?id=mc_pb_einstein_content_selection.htm&type=5';
    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/root"
      >
        <BrandBand>
          <Header route={this.props.match} />
          <Card className="content-selection-root-card" hasNoHeader>
            <div>
              <DashboardNoData
                actions={this.props.actions}
                catalogs={this.props.catalogs}
                modals={this.props.modals}
                location={this.props.location}
                history={this.props.history}
              />
              <div className="slds-grid info-cards">
                <div className="slds-col slds-size_1-of-2">
                  <InfoCard
                    headingStringId="components.ecs.infoCards.template.title"
                    descriptionStringId="components.ecs.infoCards.template.description"
                    helpLinkTextId="components.ecs.infoCards.template.helpLinkText"
                    iconName="download"
                    link="https://ecs-asset-images-nova.s3.amazonaws.com/ECS_Asset_File_Template.csv"
                  />
                </div>
                <div className="slds-col slds-size_1-of-2">
                  <InfoCard
                    headingStringId="components.ecs.infoCards.documentation.title"
                    descriptionStringId="components.ecs.infoCards.documentation.description"
                    helpLinkTextId="components.ecs.infoCards.documentation.helpLinkText"
                    iconName="help_center"
                    link={helpLink}
                  />
                </div>
              </div>
            </div>
          </Card>
          {this.renderWelcomeMat()}
        </BrandBand>
      </McMenu>
    );
  }
}

ContentSelectionWelcome.contextTypes = {
  router: PropTypes.object
};

ContentSelectionWelcome.propTypes = {
  actions: PropTypes.object,
  flags: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  const { ecs, welcomeMat, ...others } = state;
  return {
    flags: state.ecs.flags,
    ...ecs,
    welcomeMat: welcomeMat.ecs,
    ...others
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ContentSelectionWelcome)
);
